import { MatDateFormats } from '@angular/material/core';

export const NK_DATE_DEFAULT_FORMATS: MatDateFormats = {
  parse: {
    dateInput: 'll LTS'
  },
  display: {
    dateInput: 'll LTS',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY'
  }
};
